import Image from "next/image";
import Head from "next/head";
import styles from "./tnpsc-demo-class-video.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Group1preliminary from "../../assets/images/Tnpsc/TNPSC-GRI-2021-Toppers-Webbanner.webp";

const TNPSC_Demo_Classes = () => {
    return (
        <>

        <Head>
            <meta charset="UTF-8" />
            <link rel="icon" href="./logo.png" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>TNPSC Demo Classes - Shankar IAS Academy</title>
            <meta name="title" content="TNPSC Demo Classes - Shankar IAS Academy" />
            <meta name="description" content="" />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-demo-class-video/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC Demo Classes - Shankar IAS Academy" />
            <meta property="og:description" content="" />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-demo-class-video/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

        <Navbar title="tnpsc" />
        
        <div className="container">

            <div className="row">
            <div className="col pt-3 pt-md-5">
                <h1 className={`${styles.pagemaintitle}`}>TNPSC Demo Classes</h1>
            </div>
            </div>

            <div className="row">
            <div className="col pt-2 mb-3">
                <Image src={Group1preliminary} alt="TNPSC-Demo-Classes banner" title="TNPSC-Demo-Classes" className="img-fluid w-100"/>
            </div>
            </div>

            <div className="row pt-2">
            <div className="col-md-9 col-12">
                <h2 className={`${styles.sectiontitle} mb-0`}>TNPSC Demo Classes</h2>
            </div>
            </div>

        </div>

      <div className="container pt-3">
        <div className="row">
          <div className="col-12 col-lg-4 py-2">  
            <div className="nav nav-pills flex-column mb-3">
                <button id={styles.tablinks} className="nav-link my-2 py-2 px-3 active" data-bs-toggle="pill" data-bs-target="#centre-1" type="button" role="tab" aria-controls="centre-1" aria-selected="true">TNPSC Demo Class - History</button>
                <button id={styles.tablinks} className="nav-link my-2 py-2 px-3" data-bs-toggle="pill" data-bs-target="#centre-2" type="button" role="tab" aria-controls="centre-2" aria-selected="false">TNPSC Demo Class - Geography</button>
                <button id={styles.tablinks} className="nav-link my-2 py-2 px-3" data-bs-toggle="pill" data-bs-target="#centre-3" type="button" role="tab" aria-controls="centre-3" aria-selected="false">TNPSC Demo Class - Polity</button>
                <button id={styles.tablinks} className="nav-link my-2 py-2 px-3" data-bs-toggle="pill" data-bs-target="#centre-4" type="button" role="tab" aria-controls="centre-4" aria-selected="false">TNPSC Demo Class - Mental Ability</button>
                <button id={styles.tablinks} className="nav-link my-2 py-2 px-3" data-bs-toggle="pill" data-bs-target="#centre-5" type="button" role="tab" aria-controls="centre-5" aria-selected="false">TNPSC Demo Class - Economy</button>
                <button id={styles.tablinks} className="nav-link my-2 py-2 px-3" data-bs-toggle="pill" data-bs-target="#centre-6" type="button" role="tab" aria-controls="centre-6" aria-selected="false">TNPSC Demo Class - Development Administration</button>
                <button id={styles.tablinks} className="nav-link my-2 py-2 px-3" data-bs-toggle="pill" data-bs-target="#centre-7" type="button" role="tab" aria-controls="centre-7" aria-selected="false">TNPSC Demo Class - Physics</button>
                <button id={styles.tablinks} className="nav-link my-2 py-2 px-3" data-bs-toggle="pill" data-bs-target="#centre-8" type="button" role="tab" aria-controls="centre-8" aria-selected="false">TNPSC Demo Class - Chemistry</button>
                <button id={styles.tablinks} className="nav-link my-2 py-2 px-3" data-bs-toggle="pill" data-bs-target="#centre-9" type="button" role="tab" aria-controls="centre-9" aria-selected="false">TNPSC Demo Class - Botany</button>
                <button id={styles.tablinks} className="nav-link my-2 py-2 px-3  " data-bs-toggle="pill" data-bs-target="#centre-10" type="button" role="tab" aria-controls="centre-10" aria-selected="false">TNPSC Demo Class - Zoology</button>
                <button id={styles.tablinks} className="nav-link my-2 py-2 px-3" data-bs-toggle="pill" data-bs-target="#centre-11" type="button" role="tab" aria-controls="centre-11" aria-selected="false">TNPSC Demo Class - Current Affairs</button>
                <button id={styles.tablinks} className="nav-link my-2 py-2 px-3" data-bs-toggle="pill" data-bs-target="#centre-12" type="button" role="tab" aria-controls="centre-12" aria-selected="false">TNPSC Demo Class - Tamil Heritage</button>
            </div>                                                                                                                      
          </div>

          <div className="col-12 col-lg-7 col-xl-8 my-md-3 px-xl-5">
            <div className="tab-content">
                      {/* TNPSC Demo Class - History*/}
                      <div className="tab-pane active" id="centre-1">
                        <p>How to approach TNPSC Group I & II History by Mr. Subash - History Faculty</p>
                        <iframe className="w-100 videoheight"  src="https://www.youtube.com/embed/rZDFHPTJ5qg?si=qEyYv0a3ZzxTCONb"  
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                        </div>
                        {/* TNPSC Demo Class - Geography */}
                        <div className="tab-pane" id="centre-2">
                        <p>How to approach TNPSC Group I & II Geography by Mrs. Sumathi Ravichandran - Geography Faculty</p>
                        <iframe className="w-100 videoheight"  src="https://www.youtube.com/embed/32krqoyn0Bo?si=WHfsmob0HQ3ce6_w"  
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                        </div>
                        {/* TNPSC Demo Class - Polity  */}
                        <div className="tab-pane" id="centre-3">
                        <p>How to approach TNPSC Group I & II Polity by Mr. Mohan - Polity Faculty</p>
                        <iframe className="w-100 videoheight"  src="https://www.youtube.com/embed/XVa_NrIZymA?si=pA4pkRQt3XAp7tpg"  
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                        </div>
                        {/* TNPSC Demo Class - Mental Ability */}
                        <div className="tab-pane" id="centre-4">
                        <p>How to approach TNPSC Group I & II MENTAL ABILITY by Mr. Ranjith Kumar - Mental Ability Faculty</p>
                        <iframe className="w-100 videoheight"  src="https://www.youtube.com/embed/5-elFP_4AWA?si=F3Ez_BdNbT8GurxZ"  
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                        </div>
                        {/* TNPSC Demo Class - Economy */}
                        <div className="tab-pane" id="centre-5">
                        <p>How to Approach Economy part for TNPSC Group I and II - Mr. Saravanan</p>
                        <iframe className="w-100 videoheight" src="https://www.youtube.com/embed/8_vtZ3XTwJc?si=Q9FJFbtWLElx_0eq"  
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                        </div>
                        {/* TNPSC Demo Class - Development Administration */}
                        <div className="tab-pane " id="centre-6">
                        <p>How to approach TNPSC Group I & II by Mr. Parivallar - Development administration Faculty</p>
                        <iframe className="w-100 videoheight"  src="https://www.youtube.com/embed/BLIKzVN2LzE?si=cFyTXoKZ_KMpbyB3" 
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                        </div>
                        {/* TNPSC Demo Class - Physics */}
                        <div className="tab-pane" id="centre-7">
                        <p>How to approach TNPSC Group I & II Physics by N.Sucharithan -Physics /Science & Technology faculty</p>
                        <iframe className=" w-100 videoheight"  src="https://www.youtube.com/embed/D_E7PfUs-0Q?si=HBpICHt1tmaqDb5S"  
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                        </div>
                        {/* TNPSC Demo Class - Chemistry */}
                        <div className="tab-pane" id="centre-8">
                        <p>How to approach TNPSC Group I & II Chemistry by Mr.Udaiappan - Chemistry Faculty</p>
                        <iframe className="w-100 videoheight"  src="https://www.youtube.com/embed/47PqIfm7azc?si=isc_WZjkaOnLr5Ig"  
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                        </div>
                        {/* TNPSC Demo Class - Botany */}
                        <div className="tab-pane" id="centre-9">
                        <p>How to approach TNPSC Group I & II Botany by Ms.Yashodha - Botany Faculty</p>
                        <iframe className="w-100 videoheight"  src="https://www.youtube.com/embed/DSt11FQ5Q14?si=X0nDhtotdmEoVsKN"  
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                        </div>
                        {/* TNPSC Demo Class - Zoology */}
                        <div className="tab-pane" id="centre-10">
                        <p>How to approach TNPSC Group I & II Zoology by Mr.Murugan - Zoology Faculty</p>
                        <iframe className="w-100 videoheight" src="https://www.youtube.com/embed/FfvwW-ezjjY?si=Hkg4rhiaiAYXhNTD"  
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                        </div>
                        {/* TNPSC Demo Class - Current Affairs */}
                        <div className="tab-pane" id="centre-11">
                        <p>How to approach TNPSC Current affairs for Group I & II - Tips and Preparation strategy - Mr.Vigneshwaran</p>
                        <iframe className="w-100 videoheight"  src="https://www.youtube.com/embed/blfZ_mznw_8?si=L2PuBwP6r7H15Sfb"  
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                        </div>
                        {/* TNPSC Demo Class - Tamil Heritage */} 
                        <div className="tab-pane" id="centre-12">
                        <p>How to Approach Tnpsc Gr I and II unit 8 - Tamil culture and Heritage - Mr. Tamilarasan</p>
                        <iframe className="w-100 videoheight"  src="https://www.youtube.com/embed/9vncUMFbdC4?si=zDUnaY7er2nR4Ioi"  
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                        </div>
                  </div>
              </div>
        </div>
      </div>
      <Footer />                      
</>
)
}
export default TNPSC_Demo_Classes
